export const FORM_SUBMIT_BUTTON = 'form-submit-button';
export const INPUT_ERROR_MESSAGE = 'form-error-message';
